import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/homepage/image-2.png")